import {Component, OnInit} from '@angular/core';
import {CompanyDataService} from '../company-data.service';
import {Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {CompanyUploadFileService} from "../company-upload-file.service";
import {HttpResponse} from "@angular/common/http";
import {SelectFieldsTable} from "../../../../shared/select-fields.table";
import {Options} from 'select2';
import {SelectLocationTable} from '../../../../../shared/location-select.table';
import {DropdownDataTable} from '../../../../../crm/shared/dropdown-data.table';



@Component({
    selector: 'app-company-add-profile',
    templateUrl: './company-add-profile.component.html',
    styleUrls: ['./company-add-profile.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable, DropdownDataTable]
})
export class CompanyAddProfileComponent implements OnInit {
    constructor(private companyDataService: CompanyDataService,
                private router: Router,
                private companyUploadService: CompanyUploadFileService,
                private selectFields: SelectFieldsTable,
                private locationSelect: SelectLocationTable,
                private dropdownData: DropdownDataTable) {}

    formResponse: boolean;
    formSent: boolean;

    userData: any = [];
    companyData: any = [];
    companyURL: string;
    public domainOptions: Options;
    public subDomainOptions: Options;
    public singleSelectOp: Options;

    standardError: boolean = true;


    profileImageId: string;


    selectedFiles?: FileList;
    currentFile?: File;
    progress = 0;
    message = '';


    public multiSelectOp: Options;

    subdomains: any;
    subDomainsArray: any = [];

    categories: any = [];
    categoriesArray: any = [];

    selectSubdomains: any = [];

    selected: any;

    finalCategories: any = [];

    selectedCategories: any;


    selectedDomain: String = "";
    Domains: any  = this.dropdownData.domains;


    selectFile(event: any): void {
        this.selectedFiles = event.target.files;
    }

    // Domains
    htmlContent: any;
    editorConfig: AngularEditorConfig = {
        editable: true,
        height: 'auto',
        minHeight: '200px',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: 'p',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            {class: 'arial', name: 'Arial'},
            {class: 'times-new-roman', name: 'Times New Roman'},
        ],
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            ['insertImage'],
            ['fontSize'],
            ['insertVideo'],
            ['subscript'],
            ['superscript'],
            ['textColor'],
            ['backgroundColor']
        ]
    };



    // --- Dropdown for country and city
    countries = this.locationSelect.Countries;
    cities: Array<any> = [];
    changeCountry(country: any) {
        this.cities = this.countries.find((cntry: any) => cntry.name == country.target.value).cities;
    }
    // --- End of dropdown for country and city

    changeDomain(domain: any) { //Angular 11
        this.subDomainsArray = [];
        this.selectSubdomains = [];
        this.subdomains = this.Domains.find((dmn: any) => dmn.name == domain.target.value).subdomains; //Angular 11
        this.subdomains.forEach( subdomain => {
            this.subDomainsArray.push(subdomain.name);
        })
    }

    changeSubDomain(subdomain: any) { //Angular 11
        this.selected = subdomain;

        let entries = [];
        for (let entry of this.selected) {
            if (entries.indexOf(entry === -1)) {
                entries.push(entry);
            }
        }

        let newCat = [];
        for (var _i = 0; _i < entries.length; _i++) {
            var num = entries[_i];
            this.categories = this.Domains.find((dmn: any) => dmn.name == this.selectedDomain).subdomains.find((sbdmn: any) => sbdmn.name == num).categories; //Angular 11
            if (newCat.indexOf(this.categories === -1)) {
                newCat.push(this.categories );
            }
        }

        let allCat = [];
        for (var _i = 0; _i < newCat.length; _i++) {
            for ( var e = 0; e < newCat[_i].length; e++) {
                allCat.push((newCat[_i][e]));
            }
        }
        this.categoriesArray = allCat;
    }


    ngOnInit() {

        this.domainOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.subDomainOptions = {
            width: '100%',
            multiple: true,
            allowClear: true
        }

        this.singleSelectOp = {
            width: '100%',
            multiple: false,
            allowClear: false
        }

        this.multiSelectOp = {
            width: '100%',
            multiple: true,
            allowClear: false,
        }
    }


    addCompanyData(form: NgForm) {
        this.companyData = {
            companyName: form.value.companyName !== "" ? form.value.companyName : null,
            // companyLogo: form.value.companyLogo,
            companyDescription: form.value.companyDescription,
            fiscalCode: form.value.fiscalCode,
            companyAddress: form.value.companyAddress,
            country: form.value.country,
            city: form.value.city,
            vatCode: form.value.vatCode,
            activitySector: form.value.activitySector,
            companyActivitySubSector: form.value.companyActivitySubSector,
            companyMicroActivitySector: form.value.companyMicroActivitySector,
            companyType: form.value.companyType ? form.value.companyType : undefined,
            companyEmployeesLevel: form.value.companyEmployeesLevel ? form.value.companyEmployeesLevel : undefined,
            companyRevenue: form.value.companyRevenue ? form.value.companyEmployeesLevel : undefined,
            employmentThisYear: form.value.employmentThisYear ? form.value.employmentThisYear : undefined,
            employmentNextYear: form.value.employmentNextYear ? form.value.employmentNextYear : undefined,
            employmentEmergencies: form.value.employmentEmergencies ? form.value.employmentEmergencies : undefined,
            administratorFirstName: form.value.administratorFirstName ? form.value.administratorFirstName : undefined,
            administratorLastName: form.value.administratorLastName ? form.value.administratorLastName : undefined,
            administratorTelephone: form.value.administratorTelephone ? form.value.administratorTelephone : undefined,
            administratorEmail: form.value.administratorEmail ? form.value.administratorEmail : undefined,
            administratorFunction: form.value.administratorFunction ? form.value.administratorFunction : undefined,
            companySocialMedia: form.value.companySocialMedia
            // "clientOwnerId": "string",
            // "administrator": "string",
            // "numberOfEmployees": "string",
            // "numberOfSubsidiaries": "string",
            // "activityCategories": [
            //     "string"
            // ],
            // "capitalType": "INTERNAL",
            // "companyCertifications": [
            //     "string"
            // ],
            // "companyAwards": [
            //     "string"
            // ],
            // "companyTopRankings": [
            //     "string"
            // ],
            // "testimonials": "string",
            // "companyArticles": [
            //     "string"
            // ],
            // "companySocialMedia": [
            //     "string"
            // ],
            // "foundingDate": "string",
            // "agriFood_date": "string",
            // "ceo": "string"
        }


        this.companyDataService.addCompanyData(this.companyData).subscribe(resData => {

            this.companyData = resData;

            this.formResponse = true;
            this.formSent = true;

            this.upload();

            setTimeout(() => {
                this.router.navigate(['/compania-mea'])
            }, 4000);

        }, error => {

            if(error.error.reason === 'fiscalCodeAlreadyExists'){
                this.standardError = false;
            }
            this.formResponse = false;
            this.formSent = true;
        });


    }

    public upload(): void {
        this.progress = 0;

        if (this.selectedFiles) {
            const file: File | null = this.selectedFiles.item(0);

            if (file) {
                this.currentFile = file;

                this.companyUploadService.upload(this.currentFile).subscribe(
                    (event: any) => {
                        if (event instanceof HttpResponse) {
                            this.message = event.body.message;
                            // this.fileInfos = this.uploadService.getFiles();
                        }
                    },
                    (err: any) => {
                        this.progress = 0;

                        if (err.error && err.error.message) {
                            this.message = err.error.message;
                        } else {
                            this.message = 'Could not upload the file!';
                        }

                        this.currentFile = undefined;
                    });
            }
            this.selectedFiles = undefined;
        }
    }
}

